import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export const ReplyBox = ({ email, replies = [], endpoint, onSent, testId }) => {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const send = async () => {
    setSending(true);
    try {
      await api.post(endpoint, { message: text });
      toast.success(`Reply sent to ${email} from the site's email address`);
      setText("");
      onSent?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Reply failed");
    }
    setSending(false);
  };
  return (
    <div className="mt-3 space-y-2">
      {replies.map((rep, i) => (
        <div key={i} className="rounded-lg bg-sage/10 border border-sage/20 p-3" data-testid={`${testId}-reply-${i}`}>
          <p className="text-xs text-charcoal-500 mb-1">Replied by {rep.sent_by} · {new Date(rep.sent_at).toLocaleString()}</p>
          <p className="whitespace-pre-line text-sm text-charcoal-700">{rep.message}</p>
        </div>
      ))}
      {email ? (
        <div className="rounded-lg border border-sand-200 p-3">
          <p className="text-xs text-charcoal-500 mb-2">Reply to <b>{email}</b> — sent from the site's email address (Hola Movers), so they can reply straight back to your inbox.</p>
          <textarea data-testid={`${testId}-reply-text`} rows={3} value={text} onChange={(e) => setText(e.target.value)}
            placeholder="Write your reply…" className="w-full rounded-lg border border-sand-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sage/50" />
          <button data-testid={`${testId}-reply-send`} onClick={send} disabled={sending || text.trim().length < 2}
            className="mt-2 rounded-full bg-terracotta px-5 py-1.5 text-xs font-medium text-white hover:bg-terracotta-hover disabled:opacity-50">
            {sending ? "Sending…" : "Send reply"}
          </button>
        </div>
      ) : (
        <p className="text-xs text-charcoal-400">No email on this record — can't reply.</p>
      )}
    </div>
  );
};
